import { Component, OnInit } from '@angular/core';
import { LayoutService } from 'angular-admin-lte';
import { StorageService} from "./auth/storage.service";
import { MenuService } from './core/menu/menu.service';
import { MessagesService } from './messages.service';
import { environment } from '../environments/environment'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    public customLayout: boolean;
    
    public version : string = environment.version;
    public envName : string = environment.name;

    constructor(
        private layoutService: LayoutService,
        private storageService: StorageService,
        private menuService: MenuService,
        public messagesService: MessagesService
    ) { }

    ngOnInit() {
        this.layoutService.isCustomLayout.subscribe((value: boolean) => {
            this.customLayout = value;
        });

        if (this.storageService.isAuthenticated()) {
            this.menuService.fillMenu(this.storageService.getCurrentSession().menu);
        }
    }
}

